import { transformToHtml } from '../../utils/CommonUtils';
import { footerDomDT, footerDomPWA, footerIntlDT, footerIntlPWA } from '../../utils/htmlUtil/htmlFooterDT';

export const FooterOffers = (props) => {
  const { footer_data: footer, device, isIntl } = props?.data || {};
  let footerData = footer || '';
  if (device === 'mobile' && footerData === '' && isIntl) {
    footerData = footerIntlPWA;
  } else if (device === 'mobile' && footerData === '' && !isIntl) {
    footerData = footerDomPWA;
  } else if (footerData === '' && isIntl) {
    footerData = footerIntlDT;
  } else if (footerData === '') {
    footerData = footerDomDT;
  }
  return (
    <>
      <div id="seo-bottom" class="seo">
        <div id="footer_block">
          { transformToHtml(footerData)}
        </div>
        <input name="domain_id" id="domain_id" type="hidden" value="www_intl_flight_makemytrip_com" />
      </div>
    </>
  );
};
